import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { venueCancelInviteApi } from '../../api/invites/venueCancelInviteApi';

type Props = {
  venueID: string;
  onSuccess?: () => void;
};

export const useVenueCancelInviteMutation = ({ venueID, onSuccess }: Props) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation({
    mutationFn: venueCancelInviteApi,
    onSuccess: () => {
      enqueueSnackbar('Collab cancelled successfully', { variant: 'success' });
      queryClient.invalidateQueries({ queryKey: ['list-invites-v2-api', venueID] });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      enqueueSnackbar('Something went wrong while cancelling the collab request', { variant: 'error' });
    },
  });

  return mutation;
};
